__turbopack_context__.v({
  "menu": "YearMenu-module-scss-module__xN2igG__menu",
  "menu-selected": "YearMenu-module-scss-module__xN2igG__menu-selected",
  "menumobile": "YearMenu-module-scss-module__xN2igG__menumobile",
});
